import type { StaticData } from '@/siteview/entities/static-data';

import containerBack from '../textures/container-back.png';
import containerFront from '../textures/container-front.png';
import containerLeft from '../textures/container-side1.png';
import containerRight from '../textures/container-side2.png';
import containerTop from '../textures/container-top.png';
import floor from '../textures/floor.jpg';
import pcsFrontBack from '../textures/pcs-front-back.png';
import pcsSide from '../textures/pcs-side.png';
import pcsTop from '../textures/pcs-top.png';

export const data: Record<string, StaticData> = {
  '12345': {
    landscape: {
      backgroundImageSatellite: floor,
    },
    specifications: {
      dimensions: {
        Landscape: {
          width: 220,
          height: 220,
        },
        BESS: {
          width: 3,
          height: 3,
          depth: 12,
        },
        String: {
          width: 1,
          height: 3,
          depth: 12,
        },
        PCS: {
          width: 2,
          height: 1.5,
          depth: 3,
        },
        Rack: {
          width: 1,
          height: 3,
          depth: 2.16,
        },
      },
      textures: {
        BESS: {
          front: containerFront,
          back: containerBack,
          left: containerLeft,
          right: containerRight,
          top: containerTop,
        },
        PCS: {
          front: pcsFrontBack,
          back: pcsFrontBack,
          left: pcsSide,
          right: pcsSide,
          top: pcsTop,
        },
      },
    },
    containers: [
      {
        uid: '9739835394366000',
        label: 'B01',
        position: {
          x: -6,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '18510550128694977',
            position: {
              x: -7,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '20549422368304181',
            position: {
              x: -7,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '67208029915131260',
            position: {
              x: -7,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '27545060227891593',
            position: {
              x: -7,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '60601306731649707',
            position: {
              x: -7,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '63123832139559368',
            position: {
              x: -5,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '41944926425762964',
            position: {
              x: -5,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '24405506703844224',
            position: {
              x: -5,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '42272127689711786',
            position: {
              x: -5,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '6471416015895949',
            position: {
              x: -5,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '14115102612756205',
        label: 'B02',
        position: {
          x: 6,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '53412654243085819',
            position: {
              x: 5,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '41132362186614864',
            position: {
              x: 5,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '200804506794335',
            position: {
              x: 5,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '3005189968530496',
            position: {
              x: 5,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '22183080308027674',
            position: {
              x: 5,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '33153032122014401',
            position: {
              x: 7,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '11384857325292251',
            position: {
              x: 7,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '53702617871982399',
            position: {
              x: 7,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '43313190410857714',
            position: {
              x: 7,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '49587895811009218',
            position: {
              x: 7,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '65852267895348562',
        label: 'B03',
        position: {
          x: -12,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '49243845264996471',
            position: {
              x: -13,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '47799741924237567',
            position: {
              x: -13,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '19546148844086505',
            position: {
              x: -13,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '12413274228929202',
            position: {
              x: -13,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '10193385709592867',
            position: {
              x: -13,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '27325543801546025',
            position: {
              x: -11,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '25491175176508835',
            position: {
              x: -11,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '50385604783138722',
            position: {
              x: -11,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '33421511769530802',
            position: {
              x: -11,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '29970670436018244',
            position: {
              x: -11,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '32524247218213010',
        label: 'B04',
        position: {
          x: 12,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '11057815505330630',
            position: {
              x: 11,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '9964012301718093',
            position: {
              x: 11,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '68692154953849428',
            position: {
              x: 11,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '27864213323333659',
            position: {
              x: 11,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '2251106242537921',
            position: {
              x: 11,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '42230967664824705',
            position: {
              x: 13,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32398600054135596',
            position: {
              x: 13,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32228836347571270',
            position: {
              x: 13,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '43743256505231184',
            position: {
              x: 13,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '50371792209163583',
            position: {
              x: 13,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '15142662163423298',
        label: 'B05',
        position: {
          x: -18,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '25873446975477286',
            position: {
              x: -19,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '15324756511501699',
            position: {
              x: -19,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '12842385906561425',
            position: {
              x: -19,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '6754493798219001',
            position: {
              x: -19,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '46986623740661229',
            position: {
              x: -19,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '34451422262265380',
            position: {
              x: -17,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '51228206435257463',
            position: {
              x: -17,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '60935478022470524',
            position: {
              x: -17,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '47899254095945171',
            position: {
              x: -17,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '41766947065356657',
            position: {
              x: -17,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '18544298069061869',
        label: 'B06',
        position: {
          x: 18,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '5989054454777011',
            position: {
              x: 17,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '61595418260241589',
            position: {
              x: 17,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '31987574562642903',
            position: {
              x: 17,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '12499268189333681',
            position: {
              x: 17,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '34272712166528836',
            position: {
              x: 17,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '53228867100884859',
            position: {
              x: 19,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '52439835487991639',
            position: {
              x: 19,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '52458105774515491',
            position: {
              x: 19,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '15939649511646368',
            position: {
              x: 19,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '18133567724010800',
            position: {
              x: 19,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '66868980844720849',
        label: 'B07',
        position: {
          x: -24,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '9989473834664962',
            position: {
              x: -25,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '69618346777589466',
            position: {
              x: -25,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '14128602983920693',
            position: {
              x: -25,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32892454087772485',
            position: {
              x: -25,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '63377333619320009',
            position: {
              x: -25,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '35260018520653022',
            position: {
              x: -23,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '3665309423788960',
            position: {
              x: -23,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '15352581004808595',
            position: {
              x: -23,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '35916998317933242',
            position: {
              x: -23,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32872391906993377',
            position: {
              x: -23,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '47756555087370039',
        label: 'B08',
        position: {
          x: 24,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '64544906727223905',
            position: {
              x: 23,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '23152343014322097',
            position: {
              x: 23,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '3509739286086225',
            position: {
              x: 23,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '13317774037895696',
            position: {
              x: 23,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '57506560893055939',
            position: {
              x: 23,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '54611592107022391',
            position: {
              x: 25,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '68194431705816823',
            position: {
              x: 25,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '65342725437198548',
            position: {
              x: 25,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '8973983127750483',
            position: {
              x: 25,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '9163541306821944',
            position: {
              x: 25,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '48132666588666541',
        label: 'B09',
        position: {
          x: -6,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '61004656969650268',
            position: {
              x: -7,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32584793640122762',
            position: {
              x: -7,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '59449140925314565',
            position: {
              x: -7,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '68920896432152338',
            position: {
              x: -7,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '46790268423753599',
            position: {
              x: -7,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '37874475004350576',
            position: {
              x: -5,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '2958847841157008',
            position: {
              x: -5,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '26350145115484613',
            position: {
              x: -5,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32718999393037227',
            position: {
              x: -5,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '50677494698974635',
            position: {
              x: -5,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '17871600849759120',
        label: 'B10',
        position: {
          x: 6,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '785503921293096',
            position: {
              x: 5,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '24203669966234050',
            position: {
              x: 5,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '25429773579953858',
            position: {
              x: 5,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32656801140191935',
            position: {
              x: 5,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '33086645431136950',
            position: {
              x: 5,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '44821244190917697',
            position: {
              x: 7,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '15751082509800804',
            position: {
              x: 7,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '14178622165374584',
            position: {
              x: 7,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '17881726359928172',
            position: {
              x: 7,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32809988975118168',
            position: {
              x: 7,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '56724886883381766',
        label: 'B11',
        position: {
          x: -12,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '23323314879478550',
            position: {
              x: -13,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '61365916912849309',
            position: {
              x: -13,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '23468523451455008',
            position: {
              x: -13,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '829221139101683',
            position: {
              x: -13,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '8614138290846856',
            position: {
              x: -13,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '48818031772887542',
            position: {
              x: -11,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '20465382959444694',
            position: {
              x: -11,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '7332170133676183',
            position: {
              x: -11,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '67551768505398407',
            position: {
              x: -11,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '21073265830312646',
            position: {
              x: -11,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '23128282883536391',
        label: 'B12',
        position: {
          x: 12,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '18012315565896238',
            position: {
              x: 11,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '4096745221330263',
            position: {
              x: 11,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '14939940098146335',
            position: {
              x: 11,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '43096600658243782',
            position: {
              x: 11,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '46968088649331818',
            position: {
              x: 11,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '6056484481157065',
            position: {
              x: 13,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '5593354097500761',
            position: {
              x: 13,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '11827113576427829',
            position: {
              x: 13,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '69727619634080034',
            position: {
              x: 13,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '15219950701611155',
            position: {
              x: 13,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '69536875005703131',
        label: 'B13',
        position: {
          x: -18,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '46452454989978560',
            position: {
              x: -19,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '69006296838680225',
            position: {
              x: -19,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '63998850703293741',
            position: {
              x: -19,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '46949240297145001',
            position: {
              x: -19,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '399911267441666',
            position: {
              x: -19,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '48619095513868517',
            position: {
              x: -17,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '34768599284165404',
            position: {
              x: -17,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '56653590783418914',
            position: {
              x: -17,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '69842489705839361',
            position: {
              x: -17,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '57550393130509657',
            position: {
              x: -17,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '41441766571723748',
        label: 'B14',
        position: {
          x: 18,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '45297514382031054',
            position: {
              x: 17,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '62503218827957649',
            position: {
              x: 17,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '29245221879371902',
            position: {
              x: 17,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '2050947959828042',
            position: {
              x: 17,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '67770605905027679',
            position: {
              x: 17,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '25632963672790656',
            position: {
              x: 19,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '25111777456411057',
            position: {
              x: 19,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '776486031583367',
            position: {
              x: 19,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '9185293464686176',
            position: {
              x: 19,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '20307605857058898',
            position: {
              x: 19,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '60754690120106369',
        label: 'B15',
        position: {
          x: -24,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '53051536248505854',
            position: {
              x: -25,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '16613706757810192',
            position: {
              x: -25,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '62620663632847641',
            position: {
              x: -25,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '10689697607974890',
            position: {
              x: -25,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '55330563590153514',
            position: {
              x: -25,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '9700019772627367',
            position: {
              x: -23,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '70032675825587218',
            position: {
              x: -23,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '2116836727674663',
            position: {
              x: -23,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '18915650254211359',
            position: {
              x: -23,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '64661473704722937',
            position: {
              x: -23,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '9542469758485020',
        label: 'B16',
        position: {
          x: 24,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '49108634764414873',
            position: {
              x: 23,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '35889711615253138',
            position: {
              x: 23,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '12413331974127915',
            position: {
              x: 23,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '67830636093593716',
            position: {
              x: 23,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '18592466168668586',
            position: {
              x: 23,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '17858253888497353',
            position: {
              x: 25,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '71012265472545572',
            position: {
              x: 25,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '14465267306586943',
            position: {
              x: 25,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '30706446729201059',
            position: {
              x: 25,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '4820068605217853',
            position: {
              x: 25,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '15656191718307884',
        label: 'B17',
        position: {
          x: -6,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '52142253395025605',
            position: {
              x: -7,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '20333699900798398',
            position: {
              x: -7,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '61698682213406551',
            position: {
              x: -7,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '22258116000080408',
            position: {
              x: -7,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '2687068079496498',
            position: {
              x: -7,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '4090001669242293',
            position: {
              x: -5,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '21750137908642234',
            position: {
              x: -5,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '7497721837416599',
            position: {
              x: -5,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '67536427088638350',
            position: {
              x: -5,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '56988802654745276',
            position: {
              x: -5,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '62043061842966335',
        label: 'B18',
        position: {
          x: 6,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '70853358094367588',
            position: {
              x: 5,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '22159651839929015',
            position: {
              x: 5,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '61807720426445642',
            position: {
              x: 5,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '41149068504866849',
            position: {
              x: 5,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '35872618282645831',
            position: {
              x: 5,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '37450924689339264',
            position: {
              x: 7,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '57970417146406091',
            position: {
              x: 7,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '56908883118135827',
            position: {
              x: 7,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '66615624213342415',
            position: {
              x: 7,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '65081736682430764',
            position: {
              x: 7,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '1166578162839735',
        label: 'B19',
        position: {
          x: -12,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '41016897833360183',
            position: {
              x: -13,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '59330341324369333',
            position: {
              x: -13,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '40970096715439578',
            position: {
              x: -13,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '41922314307811273',
            position: {
              x: -13,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '2026255838254836',
            position: {
              x: -13,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '51865357333988480',
            position: {
              x: -11,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '6277603696836004',
            position: {
              x: -11,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '39160585113044302',
            position: {
              x: -11,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '15525746307216519',
            position: {
              x: -11,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '13750238921869415',
            position: {
              x: -11,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '65952089403350033',
        label: 'B20',
        position: {
          x: 12,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '573834764319158',
            position: {
              x: 11,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '15649704207484200',
            position: {
              x: 11,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '66087345753916469',
            position: {
              x: 11,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '34937527639391239',
            position: {
              x: 11,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '17562350934547220',
            position: {
              x: 11,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '20795102937643068',
            position: {
              x: 13,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '1625159942916716',
            position: {
              x: 13,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '29545554138899483',
            position: {
              x: 13,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '35814042208166959',
            position: {
              x: 13,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '51261903590874457',
            position: {
              x: 13,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '56779848687839874',
        label: 'B21',
        position: {
          x: -18,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '52187848566817573',
            position: {
              x: -19,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '27170204668173644',
            position: {
              x: -19,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '6204771740522162',
            position: {
              x: -19,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '20906450787144733',
            position: {
              x: -19,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '56701931486759686',
            position: {
              x: -19,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '39562889667935613',
            position: {
              x: -17,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '53494161462184094',
            position: {
              x: -17,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '34966689709591649',
            position: {
              x: -17,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '31046135398117221',
            position: {
              x: -17,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '39957277760540041',
            position: {
              x: -17,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '6190551887328680',
        label: 'B22',
        position: {
          x: 18,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '9183437896062067',
            position: {
              x: 17,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '61750720480460367',
            position: {
              x: 17,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '5009413002640889',
            position: {
              x: 17,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '10439670912067822',
            position: {
              x: 17,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '37633342627217530',
            position: {
              x: 17,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '15652258410448933',
            position: {
              x: 19,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '29853818218223332',
            position: {
              x: 19,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '62893054815165414',
            position: {
              x: 19,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '10163183405473968',
            position: {
              x: 19,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '49400842981247887',
            position: {
              x: 19,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '28227970039726226',
        label: 'B23',
        position: {
          x: -24,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '62550064869972480',
            position: {
              x: -25,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '29724370716367113',
            position: {
              x: -25,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '1610670103853015',
            position: {
              x: -25,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '69369577755331986',
            position: {
              x: -25,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '57639174054994672',
            position: {
              x: -25,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '67365459092375554',
            position: {
              x: -23,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32689711467471291',
            position: {
              x: -23,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '6978883631691550',
            position: {
              x: -23,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '38305957045744950',
            position: {
              x: -23,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '68114984296474538',
            position: {
              x: -23,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '25686743170497907',
        label: 'B24',
        position: {
          x: 24,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '17201046990530016',
            position: {
              x: 23,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '61434457278327309',
            position: {
              x: 23,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '27400757141998347',
            position: {
              x: 23,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '20110464637511486',
            position: {
              x: 23,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '45041541419960412',
            position: {
              x: 23,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '66839987110890160',
            position: {
              x: 25,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '34546484587110454',
            position: {
              x: 25,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '52855507319075531',
            position: {
              x: 25,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '31085199199260777',
            position: {
              x: 25,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '50712416082944508',
            position: {
              x: 25,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '57540051426467851',
        label: 'B25',
        position: {
          x: -6,
          y: 1.5,
          z: 33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '24504887961452069',
            position: {
              x: -7,
              y: 1.5,
              z: 28.08,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '28117427348915420',
            position: {
              x: -7,
              y: 1.5,
              z: 30.479999999999997,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '6958246851868558',
            position: {
              x: -7,
              y: 1.5,
              z: 32.879999999999995,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '2954543959903114',
            position: {
              x: -7,
              y: 1.5,
              z: 35.28,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '6540304199980755',
            position: {
              x: -7,
              y: 1.5,
              z: 37.68,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '47665735283617424',
            position: {
              x: -5,
              y: 1.5,
              z: 28.08,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '69095184924677916',
            position: {
              x: -5,
              y: 1.5,
              z: 30.479999999999997,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '24121244713338821',
            position: {
              x: -5,
              y: 1.5,
              z: 32.879999999999995,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '6429553694724504',
            position: {
              x: -5,
              y: 1.5,
              z: 35.28,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '2435862662525847',
            position: {
              x: -5,
              y: 1.5,
              z: 37.68,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '25335588316095982',
        label: 'B26',
        position: {
          x: 6,
          y: 1.5,
          z: 33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '14581783459110500',
            position: {
              x: 5,
              y: 1.5,
              z: 28.08,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '59395084066388735',
            position: {
              x: 5,
              y: 1.5,
              z: 30.479999999999997,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '17852576880260495',
            position: {
              x: 5,
              y: 1.5,
              z: 32.879999999999995,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32790652432554140',
            position: {
              x: 5,
              y: 1.5,
              z: 35.28,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '61659681451544347',
            position: {
              x: 5,
              y: 1.5,
              z: 37.68,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '40969798542131576',
            position: {
              x: 7,
              y: 1.5,
              z: 28.08,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '22596396457745528',
            position: {
              x: 7,
              y: 1.5,
              z: 30.479999999999997,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '56079652480746013',
            position: {
              x: 7,
              y: 1.5,
              z: 32.879999999999995,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '10010385498247626',
            position: {
              x: 7,
              y: 1.5,
              z: 35.28,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '30388637531089197',
            position: {
              x: 7,
              y: 1.5,
              z: 37.68,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '67465371223031458',
        label: 'B27',
        position: {
          x: -12,
          y: 1.5,
          z: 33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '67656174610726294',
            position: {
              x: -13,
              y: 1.5,
              z: 28.08,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '4061514289691207',
            position: {
              x: -13,
              y: 1.5,
              z: 30.479999999999997,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '36354892003688144',
            position: {
              x: -13,
              y: 1.5,
              z: 32.879999999999995,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32471773617279006',
            position: {
              x: -13,
              y: 1.5,
              z: 35.28,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '28545074712574921',
            position: {
              x: -13,
              y: 1.5,
              z: 37.68,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '53237918646524405',
            position: {
              x: -11,
              y: 1.5,
              z: 28.08,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '48661999858345633',
            position: {
              x: -11,
              y: 1.5,
              z: 30.479999999999997,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '35017299569429283',
            position: {
              x: -11,
              y: 1.5,
              z: 32.879999999999995,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '70410253746328374',
            position: {
              x: -11,
              y: 1.5,
              z: 35.28,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '46976829218980256',
            position: {
              x: -11,
              y: 1.5,
              z: 37.68,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '57935239604972820',
        label: 'B28',
        position: {
          x: 12,
          y: 1.5,
          z: 33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '15990764837004244',
            position: {
              x: 11,
              y: 1.5,
              z: 28.08,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '43457394153082489',
            position: {
              x: 11,
              y: 1.5,
              z: 30.479999999999997,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '13471351640558659',
            position: {
              x: 11,
              y: 1.5,
              z: 32.879999999999995,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '43257018117311641',
            position: {
              x: 11,
              y: 1.5,
              z: 35.28,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '44441210032859093',
            position: {
              x: 11,
              y: 1.5,
              z: 37.68,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '56809198314856746',
            position: {
              x: 13,
              y: 1.5,
              z: 28.08,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '52892527099087293',
            position: {
              x: 13,
              y: 1.5,
              z: 30.479999999999997,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '1517276912271249',
            position: {
              x: 13,
              y: 1.5,
              z: 32.879999999999995,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '642901347155358',
            position: {
              x: 13,
              y: 1.5,
              z: 35.28,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '16728424670061118',
            position: {
              x: 13,
              y: 1.5,
              z: 37.68,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '26038036222907881',
        label: 'B29',
        position: {
          x: -18,
          y: 1.5,
          z: 33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '46434595840970237',
            position: {
              x: -19,
              y: 1.5,
              z: 28.08,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '38611058194173256',
            position: {
              x: -19,
              y: 1.5,
              z: 30.479999999999997,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '70046936809406829',
            position: {
              x: -19,
              y: 1.5,
              z: 32.879999999999995,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '18076209839280849',
            position: {
              x: -19,
              y: 1.5,
              z: 35.28,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '54733539380796709',
            position: {
              x: -19,
              y: 1.5,
              z: 37.68,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '37167083848744828',
            position: {
              x: -17,
              y: 1.5,
              z: 28.08,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '35197177310155977',
            position: {
              x: -17,
              y: 1.5,
              z: 30.479999999999997,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '69588550128907886',
            position: {
              x: -17,
              y: 1.5,
              z: 32.879999999999995,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '54987447907194742',
            position: {
              x: -17,
              y: 1.5,
              z: 35.28,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '22959367894914781',
            position: {
              x: -17,
              y: 1.5,
              z: 37.68,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '37567530921115554',
        label: 'B30',
        position: {
          x: 18,
          y: 1.5,
          z: 33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '54426466015475921',
            position: {
              x: 17,
              y: 1.5,
              z: 28.08,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '769405584894263',
            position: {
              x: 17,
              y: 1.5,
              z: 30.479999999999997,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '44604054646835931',
            position: {
              x: 17,
              y: 1.5,
              z: 32.879999999999995,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '12242169608091269',
            position: {
              x: 17,
              y: 1.5,
              z: 35.28,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '60137551809065668',
            position: {
              x: 17,
              y: 1.5,
              z: 37.68,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '49907290519630689',
            position: {
              x: 19,
              y: 1.5,
              z: 28.08,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '39521135278296569',
            position: {
              x: 19,
              y: 1.5,
              z: 30.479999999999997,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '45762990185226657',
            position: {
              x: 19,
              y: 1.5,
              z: 32.879999999999995,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '40376310974477272',
            position: {
              x: 19,
              y: 1.5,
              z: 35.28,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '11931954233655033',
            position: {
              x: 19,
              y: 1.5,
              z: 37.68,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '29520743539604972',
        label: 'B31',
        position: {
          x: -24,
          y: 1.5,
          z: 33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '3516879690624759',
            position: {
              x: -25,
              y: 1.5,
              z: 28.08,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '36314423494654061',
            position: {
              x: -25,
              y: 1.5,
              z: 30.479999999999997,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '23741111991284011',
            position: {
              x: -25,
              y: 1.5,
              z: 32.879999999999995,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '36562173920921604',
            position: {
              x: -25,
              y: 1.5,
              z: 35.28,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '20595154266960448',
            position: {
              x: -25,
              y: 1.5,
              z: 37.68,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '42577330539636526',
            position: {
              x: -23,
              y: 1.5,
              z: 28.08,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '13713968915224737',
            position: {
              x: -23,
              y: 1.5,
              z: 30.479999999999997,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '27927971759830067',
            position: {
              x: -23,
              y: 1.5,
              z: 32.879999999999995,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '52491862310218294',
            position: {
              x: -23,
              y: 1.5,
              z: 35.28,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '35059889886841900',
            position: {
              x: -23,
              y: 1.5,
              z: 37.68,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
    ],
    pcs: [
      {
        uid: '1234501',
        label: 'PCS_01',
        position: {
          x: -6,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234502',
        label: 'PCS_02',
        position: {
          x: 6,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234503',
        label: 'PCS_03',
        position: {
          x: -12,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234504',
        label: 'PCS_04',
        position: {
          x: 12,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234505',
        label: 'PCS_05',
        position: {
          x: -18,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234506',
        label: 'PCS_06',
        position: {
          x: 18,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234507',
        label: 'PCS_07',
        position: {
          x: -24,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234508',
        label: 'PCS_08',
        position: {
          x: 24,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234509',
        label: 'PCS_09',
        position: {
          x: -6,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234510',
        label: 'PCS_10',
        position: {
          x: 6,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234511',
        label: 'PCS_11',
        position: {
          x: -12,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234512',
        label: 'PCS_12',
        position: {
          x: 12,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234513',
        label: 'PCS_13',
        position: {
          x: -18,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234514',
        label: 'PCS_14',
        position: {
          x: 18,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234515',
        label: 'PCS_15',
        position: {
          x: -24,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234516',
        label: 'PCS_16',
        position: {
          x: 24,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234517',
        label: 'PCS_17',
        position: {
          x: -6,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234518',
        label: 'PCS_18',
        position: {
          x: 6,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234519',
        label: 'PCS_19',
        position: {
          x: -12,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234520',
        label: 'PCS_20',
        position: {
          x: 12,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234521',
        label: 'PCS_21',
        position: {
          x: -18,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234522',
        label: 'PCS_22',
        position: {
          x: 18,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234523',
        label: 'PCS_23',
        position: {
          x: -24,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234524',
        label: 'PCS_24',
        position: {
          x: 24,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234525',
        label: 'PCS_25',
        position: {
          x: -6,
          y: 1.5,
          z: 40.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234526',
        label: 'PCS_26',
        position: {
          x: 6,
          y: 1.5,
          z: 40.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234527',
        label: 'PCS_27',
        position: {
          x: -12,
          y: 1.5,
          z: 40.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234528',
        label: 'PCS_28',
        position: {
          x: 12,
          y: 1.5,
          z: 40.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234529',
        label: 'PCS_29',
        position: {
          x: -18,
          y: 1.5,
          z: 40.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234530',
        label: 'PCS_30',
        position: {
          x: 18,
          y: 1.5,
          z: 40.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '1234531',
        label: 'PCS_31',
        position: {
          x: -24,
          y: 1.5,
          z: 40.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
    ],
    connections: [
      {
        uid: '97398353943660001234501',
        pcs: '1234501',
        containers: ['9739835394366000'],
      },
      {
        uid: '141151026127562051234502',
        pcs: '1234502',
        containers: ['14115102612756205'],
      },
      {
        uid: '658522678953485621234503',
        pcs: '1234503',
        containers: ['65852267895348562'],
      },
      {
        uid: '325242472182130101234504',
        pcs: '1234504',
        containers: ['32524247218213010'],
      },
      {
        uid: '151426621634232981234505',
        pcs: '1234505',
        containers: ['15142662163423298'],
      },
      {
        uid: '185442980690618691234506',
        pcs: '1234506',
        containers: ['18544298069061869'],
      },
      {
        uid: '668689808447208491234507',
        pcs: '1234507',
        containers: ['66868980844720849'],
      },
      {
        uid: '477565550873700391234508',
        pcs: '1234508',
        containers: ['47756555087370039'],
      },
      {
        uid: '481326665886665411234509',
        pcs: '1234509',
        containers: ['48132666588666541'],
      },
      {
        uid: '178716008497591201234510',
        pcs: '1234510',
        containers: ['17871600849759120'],
      },
      {
        uid: '567248868833817661234511',
        pcs: '1234511',
        containers: ['56724886883381766'],
      },
      {
        uid: '231282828835363911234512',
        pcs: '1234512',
        containers: ['23128282883536391'],
      },
      {
        uid: '695368750057031311234513',
        pcs: '1234513',
        containers: ['69536875005703131'],
      },
      {
        uid: '414417665717237481234514',
        pcs: '1234514',
        containers: ['41441766571723748'],
      },
      {
        uid: '607546901201063691234515',
        pcs: '1234515',
        containers: ['60754690120106369'],
      },
      {
        uid: '95424697584850201234516',
        pcs: '1234516',
        containers: ['9542469758485020'],
      },
      {
        uid: '156561917183078841234517',
        pcs: '1234517',
        containers: ['15656191718307884'],
      },
      {
        uid: '620430618429663351234518',
        pcs: '1234518',
        containers: ['62043061842966335'],
      },
      {
        uid: '11665781628397351234519',
        pcs: '1234519',
        containers: ['1166578162839735'],
      },
      {
        uid: '659520894033500331234520',
        pcs: '1234520',
        containers: ['65952089403350033'],
      },
      {
        uid: '567798486878398741234521',
        pcs: '1234521',
        containers: ['56779848687839874'],
      },
      {
        uid: '61905518873286801234522',
        pcs: '1234522',
        containers: ['6190551887328680'],
      },
      {
        uid: '282279700397262261234523',
        pcs: '1234523',
        containers: ['28227970039726226'],
      },
      {
        uid: '256867431704979071234524',
        pcs: '1234524',
        containers: ['25686743170497907'],
      },
      {
        uid: '575400514264678511234525',
        pcs: '1234525',
        containers: ['57540051426467851'],
      },
      {
        uid: '253355883160959821234526',
        pcs: '1234526',
        containers: ['25335588316095982'],
      },
      {
        uid: '674653712230314581234527',
        pcs: '1234527',
        containers: ['67465371223031458'],
      },
      {
        uid: '579352396049728201234528',
        pcs: '1234528',
        containers: ['57935239604972820'],
      },
      {
        uid: '260380362229078811234529',
        pcs: '1234529',
        containers: ['26038036222907881'],
      },
      {
        uid: '375675309211155541234530',
        pcs: '1234530',
        containers: ['37567530921115554'],
      },
      {
        uid: '295207435396049721234531',
        pcs: '1234531',
        containers: ['29520743539604972'],
      },
    ],
  },
  '23456': {
    landscape: {
      backgroundImageSatellite: floor,
    },
    specifications: {
      dimensions: {
        Landscape: {
          width: 220,
          height: 220,
        },
        BESS: {
          width: 3,
          height: 3,
          depth: 12,
        },
        String: {
          width: 1,
          height: 3,
          depth: 12,
        },
        PCS: {
          width: 2,
          height: 1.5,
          depth: 3,
        },
        Rack: {
          width: 1,
          height: 3,
          depth: 2.16,
        },
      },
      textures: {
        BESS: {
          front: containerFront,
          back: containerBack,
          left: containerLeft,
          right: containerRight,
          top: containerTop,
        },
        PCS: {
          front: pcsFrontBack,
          back: pcsFrontBack,
          left: pcsSide,
          right: pcsSide,
          top: pcsTop,
        },
      },
    },
    containers: [
      {
        uid: '30718404103119905',
        label: 'B01',
        position: {
          x: -6,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '35079599492552134',
            position: {
              x: -7,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '60657763325243915',
            position: {
              x: -7,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '43258961377223634',
            position: {
              x: -7,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '23354183706937396',
            position: {
              x: -7,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '1848370142396384',
            position: {
              x: -7,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '18480505217750404',
            position: {
              x: -5,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '43744028884453053',
            position: {
              x: -5,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '17553539178570896',
            position: {
              x: -5,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '22692834682381922',
            position: {
              x: -5,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '335446477564378',
            position: {
              x: -5,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '20132512127652605',
        label: 'B02',
        position: {
          x: 6,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '62459970151819100',
            position: {
              x: 5,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '28726395311334323',
            position: {
              x: 5,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '71351724769407902',
            position: {
              x: 5,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '41945816501081001',
            position: {
              x: 5,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '53265910630541263',
            position: {
              x: 5,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '21037161735465121',
            position: {
              x: 7,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '23563816371734243',
            position: {
              x: 7,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '68483868567566294',
            position: {
              x: 7,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '38135837023795626',
            position: {
              x: 7,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '38904549177912417',
            position: {
              x: 7,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '26375145252243301',
        label: 'B03',
        position: {
          x: -12,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '30714843013249091',
            position: {
              x: -13,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '25788169519644835',
            position: {
              x: -13,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '51197728079149998',
            position: {
              x: -13,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '67052612123657520',
            position: {
              x: -13,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '50017465982186910',
            position: {
              x: -13,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '65050616771379947',
            position: {
              x: -11,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '20647062452501250',
            position: {
              x: -11,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '55047696560349703',
            position: {
              x: -11,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '57672893553099070',
            position: {
              x: -11,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '46294422344634429',
            position: {
              x: -11,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '40744635163444372',
        label: 'B04',
        position: {
          x: 12,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '21031235340488397',
            position: {
              x: 11,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '52104864305480172',
            position: {
              x: 11,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '14078335744370971',
            position: {
              x: 11,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '20280190013234747',
            position: {
              x: 11,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '59713406893582856',
            position: {
              x: 11,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '11850571627739532',
            position: {
              x: 13,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '15619113561839834',
            position: {
              x: 13,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '56019295785122494',
            position: {
              x: 13,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '45233964787214109',
            position: {
              x: 13,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '25285983738490723',
            position: {
              x: 13,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '47538560548968574',
        label: 'B05',
        position: {
          x: -18,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '63358222093392503',
            position: {
              x: -19,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '20917327876710154',
            position: {
              x: -19,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '59723555043838889',
            position: {
              x: -19,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '71731959769522196',
            position: {
              x: -19,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '35527547318755671',
            position: {
              x: -19,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '2160660447756477',
            position: {
              x: -17,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '60955602330446930',
            position: {
              x: -17,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '12129653793088123',
            position: {
              x: -17,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '69127980137566436',
            position: {
              x: -17,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '7177186809680055',
            position: {
              x: -17,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '31073992737191951',
        label: 'B06',
        position: {
          x: 18,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '9175395037137693',
            position: {
              x: 17,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '43840062496099364',
            position: {
              x: 17,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '42336978694889711',
            position: {
              x: 17,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '31450277216898505',
            position: {
              x: 17,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '27192598374848000',
            position: {
              x: 17,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '28102434435720603',
            position: {
              x: 19,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '67399618892451013',
            position: {
              x: 19,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '33778278923414646',
            position: {
              x: 19,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '58760079855280155',
            position: {
              x: 19,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '34135204102489899',
            position: {
              x: 19,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '5646263683372337',
        label: 'B07',
        position: {
          x: -24,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '32437083433113149',
            position: {
              x: -25,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '4416030866688505',
            position: {
              x: -25,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '39763829747641606',
            position: {
              x: -25,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '49909109682713087',
            position: {
              x: -25,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '47543278782853757',
            position: {
              x: -25,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '8670882970050692',
            position: {
              x: -23,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '27283040611375227',
            position: {
              x: -23,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '38035985200834664',
            position: {
              x: -23,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '12174772515007284',
            position: {
              x: -23,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '65698748464844387',
            position: {
              x: -23,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '25095599520628136',
        label: 'B08',
        position: {
          x: 24,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '57142606006411498',
            position: {
              x: 23,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '10958493489220936',
            position: {
              x: 23,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '14754308508559561',
            position: {
              x: 23,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '37940774952553839',
            position: {
              x: 23,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '43509776735966515',
            position: {
              x: 23,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '58135030007642909',
            position: {
              x: 25,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '31414145010902092',
            position: {
              x: 25,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '17818051774895706',
            position: {
              x: 25,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '21013071767130086',
            position: {
              x: 25,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '10801577876736588',
            position: {
              x: 25,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '1869295039075929',
        label: 'B09',
        position: {
          x: -6,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '11375593899123091',
            position: {
              x: -7,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '47381622689104084',
            position: {
              x: -7,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '55709521646384897',
            position: {
              x: -7,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '7302099969241602',
            position: {
              x: -7,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '70994875044936437',
            position: {
              x: -7,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '16576714102091540',
            position: {
              x: -5,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '22491353107430450',
            position: {
              x: -5,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '71333124671386150',
            position: {
              x: -5,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '48508834435066572',
            position: {
              x: -5,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '69392820513795688',
            position: {
              x: -5,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '7188901685439760',
        label: 'B10',
        position: {
          x: 6,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '32660616734568296',
            position: {
              x: 5,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '60902590282422794',
            position: {
              x: 5,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '57024869034213961',
            position: {
              x: 5,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '782363481701581',
            position: {
              x: 5,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '17633189750374630',
            position: {
              x: 5,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '69530651245263361',
            position: {
              x: 7,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '48496545838971648',
            position: {
              x: 7,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '66841037154927878',
            position: {
              x: 7,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '70285715384723094',
            position: {
              x: 7,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '63758290874505012',
            position: {
              x: 7,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '37587440701671119',
        label: 'B11',
        position: {
          x: -12,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '28124858374632774',
            position: {
              x: -13,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '47245680462390628',
            position: {
              x: -13,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '45277147157392250',
            position: {
              x: -13,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '60679825139275974',
            position: {
              x: -13,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '56721372420565342',
            position: {
              x: -13,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '22447779129517378',
            position: {
              x: -11,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '5053232663135502',
            position: {
              x: -11,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '69456142569331638',
            position: {
              x: -11,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '31562446424791925',
            position: {
              x: -11,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '67775263096565749',
            position: {
              x: -11,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '31646670405234952',
        label: 'B12',
        position: {
          x: 12,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '57654656088194761',
            position: {
              x: 11,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '69268198814781637',
            position: {
              x: 11,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '12958175526162777',
            position: {
              x: 11,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '55125871943037286',
            position: {
              x: 11,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '56101294836430947',
            position: {
              x: 11,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '19837581716408589',
            position: {
              x: 13,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '56685402963130941',
            position: {
              x: 13,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '71429198033057053',
            position: {
              x: 13,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '19246583507602064',
            position: {
              x: 13,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '12846182028686806',
            position: {
              x: 13,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '63112088927389728',
        label: 'B13',
        position: {
          x: -18,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '51222084024797903',
            position: {
              x: -19,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '39170229262137232',
            position: {
              x: -19,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '3959540137519683',
            position: {
              x: -19,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '71907166678705129',
            position: {
              x: -19,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '2555834305027008',
            position: {
              x: -19,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '60725584928870431',
            position: {
              x: -17,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '66285326418257502',
            position: {
              x: -17,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '4958850007594793',
            position: {
              x: -17,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '23720656675694581',
            position: {
              x: -17,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '1076878984484970',
            position: {
              x: -17,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '71598940471247509',
        label: 'B14',
        position: {
          x: 18,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '23606146050822795',
            position: {
              x: 17,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '44938263530984610',
            position: {
              x: 17,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '61178743930976533',
            position: {
              x: 17,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '13560460717256566',
            position: {
              x: 17,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '54307276412371338',
            position: {
              x: 17,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '50815937617313589',
            position: {
              x: 19,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '3924482271833987',
            position: {
              x: 19,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '35662694575693330',
            position: {
              x: 19,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '8046538368927418',
            position: {
              x: 19,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '33278398670163058',
            position: {
              x: 19,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '30419150012822155',
        label: 'B15',
        position: {
          x: -24,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '13744263605342591',
            position: {
              x: -25,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '24013042471477128',
            position: {
              x: -25,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '33017895459320372',
            position: {
              x: -25,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '13955951463951367',
            position: {
              x: -25,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '68227863705749090',
            position: {
              x: -25,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '19560451941931963',
            position: {
              x: -23,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '48947680750511434',
            position: {
              x: -23,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '24607581275318618',
            position: {
              x: -23,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '43127281990156594',
            position: {
              x: -23,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '49125336693456848',
            position: {
              x: -23,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '44704272828581916',
        label: 'B16',
        position: {
          x: 24,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '42258704915988588',
            position: {
              x: 23,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '45160022361051610',
            position: {
              x: 23,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '206388036881247',
            position: {
              x: 23,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '22164310707695651',
            position: {
              x: 23,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '24697274947705184',
            position: {
              x: 23,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '60233673394640248',
            position: {
              x: 25,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '17580527052179391',
            position: {
              x: 25,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '33521742613704712',
            position: {
              x: 25,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '18833102232759435',
            position: {
              x: 25,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '17913064679708754',
            position: {
              x: 25,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '58234417308923101',
        label: 'B17',
        position: {
          x: -6,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '53828508804375926',
            position: {
              x: -7,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '48670519692338213',
            position: {
              x: -7,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '13208265763049318',
            position: {
              x: -7,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '19552475340290172',
            position: {
              x: -7,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '4898952035945218',
            position: {
              x: -7,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '15850813590925959',
            position: {
              x: -5,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '52521187362286770',
            position: {
              x: -5,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '54430293987184687',
            position: {
              x: -5,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '23213235943792871',
            position: {
              x: -5,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '26385332725240731',
            position: {
              x: -5,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '71738629612187595',
        label: 'B18',
        position: {
          x: 6,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '43089236366906994',
            position: {
              x: 5,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '63768954693150466',
            position: {
              x: 5,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '35095534864345407',
            position: {
              x: 5,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '17801485971336608',
            position: {
              x: 5,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '49077479741439416',
            position: {
              x: 5,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '45129314086819167',
            position: {
              x: 7,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '6179717183598613',
            position: {
              x: 7,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '37367737864105152',
            position: {
              x: 7,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '69588164753444757',
            position: {
              x: 7,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '68228446603551146',
            position: {
              x: 7,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '35411598728802570',
        label: 'B19',
        position: {
          x: -12,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '17284153773455137',
            position: {
              x: -13,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '48806938598024116',
            position: {
              x: -13,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '11986804017601896',
            position: {
              x: -13,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '61098197719043385',
            position: {
              x: -13,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '66184847427690058',
            position: {
              x: -13,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '26575516861154073',
            position: {
              x: -11,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '34619842153783870',
            position: {
              x: -11,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '10040882121069437',
            position: {
              x: -11,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '60695585843713864',
            position: {
              x: -11,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '26927875387232999',
            position: {
              x: -11,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
    ],
    pcs: [
      {
        uid: '2345601',
        label: 'PCS_01',
        position: {
          x: -6,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345602',
        label: 'PCS_02',
        position: {
          x: 6,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345603',
        label: 'PCS_03',
        position: {
          x: -12,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345604',
        label: 'PCS_04',
        position: {
          x: 12,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345605',
        label: 'PCS_05',
        position: {
          x: -18,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345606',
        label: 'PCS_06',
        position: {
          x: 18,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345607',
        label: 'PCS_07',
        position: {
          x: -24,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345608',
        label: 'PCS_08',
        position: {
          x: 24,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345609',
        label: 'PCS_09',
        position: {
          x: -6,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345610',
        label: 'PCS_10',
        position: {
          x: 6,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345611',
        label: 'PCS_11',
        position: {
          x: -12,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345612',
        label: 'PCS_12',
        position: {
          x: 12,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345613',
        label: 'PCS_13',
        position: {
          x: -18,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345614',
        label: 'PCS_14',
        position: {
          x: 18,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345615',
        label: 'PCS_15',
        position: {
          x: -24,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345616',
        label: 'PCS_16',
        position: {
          x: 24,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345617',
        label: 'PCS_17',
        position: {
          x: -6,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345618',
        label: 'PCS_18',
        position: {
          x: 6,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '2345619',
        label: 'PCS_19',
        position: {
          x: -12,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
    ],
    connections: [
      {
        uid: '307184041031199052345601',
        pcs: '2345601',
        containers: ['30718404103119905'],
      },
      {
        uid: '201325121276526052345602',
        pcs: '2345602',
        containers: ['20132512127652605'],
      },
      {
        uid: '263751452522433012345603',
        pcs: '2345603',
        containers: ['26375145252243301'],
      },
      {
        uid: '407446351634443722345604',
        pcs: '2345604',
        containers: ['40744635163444372'],
      },
      {
        uid: '475385605489685742345605',
        pcs: '2345605',
        containers: ['47538560548968574'],
      },
      {
        uid: '310739927371919512345606',
        pcs: '2345606',
        containers: ['31073992737191951'],
      },
      {
        uid: '56462636833723372345607',
        pcs: '2345607',
        containers: ['5646263683372337'],
      },
      {
        uid: '250955995206281362345608',
        pcs: '2345608',
        containers: ['25095599520628136'],
      },
      {
        uid: '18692950390759292345609',
        pcs: '2345609',
        containers: ['1869295039075929'],
      },
      {
        uid: '71889016854397602345610',
        pcs: '2345610',
        containers: ['7188901685439760'],
      },
      {
        uid: '375874407016711192345611',
        pcs: '2345611',
        containers: ['37587440701671119'],
      },
      {
        uid: '316466704052349522345612',
        pcs: '2345612',
        containers: ['31646670405234952'],
      },
      {
        uid: '631120889273897282345613',
        pcs: '2345613',
        containers: ['63112088927389728'],
      },
      {
        uid: '715989404712475092345614',
        pcs: '2345614',
        containers: ['71598940471247509'],
      },
      {
        uid: '304191500128221552345615',
        pcs: '2345615',
        containers: ['30419150012822155'],
      },
      {
        uid: '447042728285819162345616',
        pcs: '2345616',
        containers: ['44704272828581916'],
      },
      {
        uid: '582344173089231012345617',
        pcs: '2345617',
        containers: ['58234417308923101'],
      },
      {
        uid: '717386296121875952345618',
        pcs: '2345618',
        containers: ['71738629612187595'],
      },
      {
        uid: '354115987288025702345619',
        pcs: '2345619',
        containers: ['35411598728802570'],
      },
    ],
  },
  '34567': {
    landscape: {
      backgroundImageSatellite: floor,
    },
    specifications: {
      dimensions: {
        Landscape: {
          width: 220,
          height: 220,
        },
        BESS: {
          width: 3,
          height: 3,
          depth: 12,
        },
        String: {
          width: 1,
          height: 3,
          depth: 12,
        },
        PCS: {
          width: 2,
          height: 1.5,
          depth: 3,
        },
        Rack: {
          width: 1,
          height: 3,
          depth: 2.16,
        },
      },
      textures: {
        BESS: {
          front: containerFront,
          back: containerBack,
          left: containerLeft,
          right: containerRight,
          top: containerTop,
        },
        PCS: {
          front: pcsFrontBack,
          back: pcsFrontBack,
          left: pcsSide,
          right: pcsSide,
          top: pcsTop,
        },
      },
    },
    containers: [
      {
        uid: '68810249463363542',
        label: 'B01',
        position: {
          x: -6,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '44262786570105247',
            position: {
              x: -7,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '26905524237387724',
            position: {
              x: -7,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '43266919750272151',
            position: {
              x: -7,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '59086561782369494',
            position: {
              x: -7,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '4655539236530224',
            position: {
              x: -7,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '66684427417835148',
            position: {
              x: -5,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '44378986949131962',
            position: {
              x: -5,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '26688779656110660',
        label: 'B02',
        position: {
          x: 6,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '6235619112861210',
            position: {
              x: 5,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32005371243043353',
            position: {
              x: 5,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '65123223871815290',
            position: {
              x: 5,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '18568289531407894',
            position: {
              x: 5,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '7094469504664286',
            position: {
              x: 5,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '36078247376804333',
            position: {
              x: 7,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '36209438535110631',
            position: {
              x: 7,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '5208048146371065',
        label: 'B03',
        position: {
          x: -12,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '35318091892249771',
            position: {
              x: -13,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '14107409534745415',
            position: {
              x: -13,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '49734039780099825',
            position: {
              x: -13,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '41650961282610639',
            position: {
              x: -13,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '62762969003009503',
            position: {
              x: -13,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '41265578664303445',
            position: {
              x: -11,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '52000826579640257',
            position: {
              x: -11,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '52095245272996909',
        label: 'B04',
        position: {
          x: 12,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '38659240387588959',
            position: {
              x: 11,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '31333048061248156',
            position: {
              x: 11,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '49447700021204043',
            position: {
              x: 11,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '17141526905007658',
            position: {
              x: 11,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32434374897784146',
            position: {
              x: 11,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '24277162998605119',
            position: {
              x: 13,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '47209317785957315',
            position: {
              x: 13,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '62951201805066422',
        label: 'B05',
        position: {
          x: -18,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '61939568820839264',
            position: {
              x: -19,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '47907067275323195',
            position: {
              x: -19,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '48526863698603864',
            position: {
              x: -19,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '25250069974272448',
            position: {
              x: -19,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '5856479230073424',
            position: {
              x: -19,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '20471540913518535',
            position: {
              x: -17,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '50603710744382028',
            position: {
              x: -17,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '42935953921198998',
        label: 'B06',
        position: {
          x: 18,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '21633242953326513',
            position: {
              x: 17,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '63716930169321346',
            position: {
              x: 17,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '4337717586297350',
            position: {
              x: 17,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '1816065337026227',
            position: {
              x: 17,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '23078986167548976',
            position: {
              x: 17,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '37061098950414129',
            position: {
              x: 19,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '46039135135769811',
            position: {
              x: 19,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '54380859669690804',
        label: 'B07',
        position: {
          x: -24,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '56395827885335761',
            position: {
              x: -25,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '68288132438534195',
            position: {
              x: -25,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '42520939806310753',
            position: {
              x: -25,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '14659260481768716',
            position: {
              x: -25,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '9308028791642601',
            position: {
              x: -25,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '42580670235822364',
            position: {
              x: -23,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '7037076435548809',
            position: {
              x: -23,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '55999870768132519',
        label: 'B08',
        position: {
          x: 24,
          y: 1.5,
          z: -16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '2538918863590415',
            position: {
              x: 23,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '36828021029146421',
            position: {
              x: 23,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '51461022411741932',
            position: {
              x: 23,
              y: 1.5,
              z: -16.62,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '62334855922460872',
            position: {
              x: 23,
              y: 1.5,
              z: -14.22,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '25139187188403141',
            position: {
              x: 23,
              y: 1.5,
              z: -11.82,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '59702983162494328',
            position: {
              x: 25,
              y: 1.5,
              z: -21.42,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '25492131571971810',
            position: {
              x: 25,
              y: 1.5,
              z: -19.020000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '17590262253897322',
        label: 'B09',
        position: {
          x: -6,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '7768783131568285',
            position: {
              x: -7,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '25163592552586681',
            position: {
              x: -7,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '26613609825343367',
            position: {
              x: -7,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '28253986343896803',
            position: {
              x: -7,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '31090759195636136',
            position: {
              x: -7,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '67340213169365601',
            position: {
              x: -5,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '51937854157168776',
        label: 'B10',
        position: {
          x: 6,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '11158484892686668',
            position: {
              x: 5,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '68927473038752950',
            position: {
              x: 5,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '50436436145897532',
            position: {
              x: 5,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '39820713219009219',
            position: {
              x: 5,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '49339515477753697',
            position: {
              x: 5,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '28724523743614418',
            position: {
              x: 7,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '90998129563161',
        label: 'B11',
        position: {
          x: -12,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '13376914750853058',
            position: {
              x: -13,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '56841109492578227',
            position: {
              x: -13,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '10946992763985964',
            position: {
              x: -13,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '35323450106053539',
            position: {
              x: -13,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '3521236114852592',
            position: {
              x: -13,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '13008081726865069',
            position: {
              x: -11,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '20240335320536014',
        label: 'B12',
        position: {
          x: 12,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '49552413449274128',
            position: {
              x: 11,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '30191853110409596',
            position: {
              x: 11,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '28070762464680969',
            position: {
              x: 11,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '69832781860857833',
            position: {
              x: 11,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '22891281137356005',
            position: {
              x: 11,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32052106622291805',
            position: {
              x: 13,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '20859898438017379',
        label: 'B13',
        position: {
          x: -18,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '38113168415355033',
            position: {
              x: -19,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '14302806928450382',
            position: {
              x: -19,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '62376281187427261',
            position: {
              x: -19,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '17255494565430446',
            position: {
              x: -19,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '7023040110786477',
            position: {
              x: -19,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '26764239342805376',
            position: {
              x: -17,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '30553784399725380',
            position: {
              x: -17,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '7968654005981071',
        label: 'B14',
        position: {
          x: 18,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '47066440660800271',
            position: {
              x: 17,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '13412229836202362',
            position: {
              x: 17,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '3602344568108499',
            position: {
              x: 17,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '44577104628557354',
            position: {
              x: 17,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '30492556676042766',
            position: {
              x: 17,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '70071017920417767',
            position: {
              x: 19,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '33143413568738102',
            position: {
              x: 19,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '28520624921613308',
        label: 'B15',
        position: {
          x: -24,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '21653856199572797',
            position: {
              x: -25,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '27365264825782934',
            position: {
              x: -25,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '63557573616345587',
            position: {
              x: -25,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '23181206242594511',
            position: {
              x: -25,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '62480409727017366',
            position: {
              x: -25,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '14158364375943252',
            position: {
              x: -23,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '11314509918393158',
            position: {
              x: -23,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '14397688147389146',
        label: 'B16',
        position: {
          x: 24,
          y: 1.5,
          z: 16.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '17178712120278320',
            position: {
              x: 23,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '26682097369265135',
            position: {
              x: 23,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '23166424732939833',
            position: {
              x: 23,
              y: 1.5,
              z: 16.380000000000003,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '52378953485546685',
            position: {
              x: 23,
              y: 1.5,
              z: 18.78,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '17927613245815604',
            position: {
              x: 23,
              y: 1.5,
              z: 21.18,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '65784297568105507',
            position: {
              x: 25,
              y: 1.5,
              z: 11.58,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '8656234036716442',
            position: {
              x: 25,
              y: 1.5,
              z: 13.98,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '4973799425202413',
        label: 'B17',
        position: {
          x: -6,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '10110088247115396',
            position: {
              x: -7,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '2053692546559302',
            position: {
              x: -7,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '70581178585199271',
            position: {
              x: -7,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '52500410976540328',
            position: {
              x: -7,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '24956673337015736',
            position: {
              x: -7,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '35910466305307305',
            position: {
              x: -5,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32300504484497934',
            position: {
              x: -5,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '70720494449034970',
        label: 'B18',
        position: {
          x: 6,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '50619950495859730',
            position: {
              x: 5,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '38645722419021758',
            position: {
              x: 5,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '28862791299318153',
            position: {
              x: 5,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '45065540055841262',
            position: {
              x: 5,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '38070773761938067',
            position: {
              x: 5,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '63722519976061634',
            position: {
              x: 7,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '52481637789387812',
            position: {
              x: 7,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '52453168776388276',
        label: 'B19',
        position: {
          x: -12,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '48688770396985074',
            position: {
              x: -13,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '14460835168906315',
            position: {
              x: -13,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '52998696880078229',
            position: {
              x: -13,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '31443814677279121',
            position: {
              x: -13,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '49265051464892748',
            position: {
              x: -13,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '38695840649889281',
            position: {
              x: -11,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '1495526027727418',
            position: {
              x: -11,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '65006415899326271',
        label: 'B20',
        position: {
          x: 12,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '48971081830872427',
            position: {
              x: 11,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '48757661508021137',
            position: {
              x: 11,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '4809815686882139',
            position: {
              x: 11,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '48860916300418370',
            position: {
              x: 11,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '7158730309284118',
            position: {
              x: 11,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '45886904170386958',
            position: {
              x: 13,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '41779508507157494',
            position: {
              x: 13,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '4671598442638018',
        label: 'B21',
        position: {
          x: -18,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '49858423950880505',
            position: {
              x: -19,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '46870689238557165',
            position: {
              x: -19,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '40768168588328948',
            position: {
              x: -19,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '56563756851894281',
            position: {
              x: -19,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '63486783724460205',
            position: {
              x: -19,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '17145910332195513',
            position: {
              x: -17,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '2612182939287076',
        label: 'B22',
        position: {
          x: 18,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '53382178548989907',
            position: {
              x: 17,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '71499463918202387',
            position: {
              x: 17,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '34365075744484327',
            position: {
              x: 17,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '70713094701696135',
            position: {
              x: 17,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '35413507095972812',
            position: {
              x: 17,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '30429192677332961',
            position: {
              x: 19,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '25931767534931922',
        label: 'B23',
        position: {
          x: -24,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '48252989460899083',
            position: {
              x: -25,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '6489621000364283',
            position: {
              x: -25,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '65365547490194511',
            position: {
              x: -25,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '60789031339525557',
            position: {
              x: -25,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '32266837888722812',
            position: {
              x: -25,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '27329678242489183',
            position: {
              x: -23,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
      {
        uid: '12521425487257130',
        label: 'B24',
        position: {
          x: 24,
          y: 1.5,
          z: -33,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
        racks: [
          {
            uid: '19444713267498720',
            position: {
              x: 23,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '2094862441585329',
            position: {
              x: 23,
              y: 1.5,
              z: -35.52,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '53965937023473965',
            position: {
              x: 23,
              y: 1.5,
              z: -33.120000000000005,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '71460987189680773',
            position: {
              x: 23,
              y: 1.5,
              z: -30.72,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '27728366972216984',
            position: {
              x: 23,
              y: 1.5,
              z: -28.32,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
          {
            uid: '48444700418667565',
            position: {
              x: 25,
              y: 1.5,
              z: -37.92,
            },
            rotation: {
              x: 0,
              y: 0,
              z: 0,
            },
          },
        ],
      },
    ],
    pcs: [
      {
        uid: '3456701',
        label: 'PCS_01',
        position: {
          x: -6,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456702',
        label: 'PCS_02',
        position: {
          x: 6,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456703',
        label: 'PCS_03',
        position: {
          x: -12,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456704',
        label: 'PCS_04',
        position: {
          x: 12,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456705',
        label: 'PCS_05',
        position: {
          x: -18,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456706',
        label: 'PCS_06',
        position: {
          x: 18,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456707',
        label: 'PCS_07',
        position: {
          x: -24,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456708',
        label: 'PCS_08',
        position: {
          x: 24,
          y: 1.5,
          z: -9,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456709',
        label: 'PCS_09',
        position: {
          x: -6,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456710',
        label: 'PCS_10',
        position: {
          x: 6,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456711',
        label: 'PCS_11',
        position: {
          x: -12,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456712',
        label: 'PCS_12',
        position: {
          x: 12,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456713',
        label: 'PCS_13',
        position: {
          x: -18,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456714',
        label: 'PCS_14',
        position: {
          x: 18,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456715',
        label: 'PCS_15',
        position: {
          x: -24,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456716',
        label: 'PCS_16',
        position: {
          x: 24,
          y: 1.5,
          z: 24,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456717',
        label: 'PCS_17',
        position: {
          x: -6,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456718',
        label: 'PCS_18',
        position: {
          x: 6,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456719',
        label: 'PCS_19',
        position: {
          x: -12,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456720',
        label: 'PCS_20',
        position: {
          x: 12,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456721',
        label: 'PCS_21',
        position: {
          x: -18,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456722',
        label: 'PCS_22',
        position: {
          x: 18,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456723',
        label: 'PCS_23',
        position: {
          x: -24,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
      {
        uid: '3456724',
        label: 'PCS_24',
        position: {
          x: 24,
          y: 1.5,
          z: -25.5,
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0,
        },
      },
    ],
    connections: [
      {
        uid: '688102494633635423456701',
        pcs: '3456701',
        containers: ['68810249463363542'],
      },
      {
        uid: '266887796561106603456702',
        pcs: '3456702',
        containers: ['26688779656110660'],
      },
      {
        uid: '52080481463710653456703',
        pcs: '3456703',
        containers: ['5208048146371065'],
      },
      {
        uid: '520952452729969093456704',
        pcs: '3456704',
        containers: ['52095245272996909'],
      },
      {
        uid: '629512018050664223456705',
        pcs: '3456705',
        containers: ['62951201805066422'],
      },
      {
        uid: '429359539211989983456706',
        pcs: '3456706',
        containers: ['42935953921198998'],
      },
      {
        uid: '543808596696908043456707',
        pcs: '3456707',
        containers: ['54380859669690804'],
      },
      {
        uid: '559998707681325193456708',
        pcs: '3456708',
        containers: ['55999870768132519'],
      },
      {
        uid: '175902622538973223456709',
        pcs: '3456709',
        containers: ['17590262253897322'],
      },
      {
        uid: '519378541571687763456710',
        pcs: '3456710',
        containers: ['51937854157168776'],
      },
      {
        uid: '909981295631613456711',
        pcs: '3456711',
        containers: ['90998129563161'],
      },
      {
        uid: '202403353205360143456712',
        pcs: '3456712',
        containers: ['20240335320536014'],
      },
      {
        uid: '208598984380173793456713',
        pcs: '3456713',
        containers: ['20859898438017379'],
      },
      {
        uid: '79686540059810713456714',
        pcs: '3456714',
        containers: ['7968654005981071'],
      },
      {
        uid: '285206249216133083456715',
        pcs: '3456715',
        containers: ['28520624921613308'],
      },
      {
        uid: '143976881473891463456716',
        pcs: '3456716',
        containers: ['14397688147389146'],
      },
      {
        uid: '49737994252024133456717',
        pcs: '3456717',
        containers: ['4973799425202413'],
      },
      {
        uid: '707204944490349703456718',
        pcs: '3456718',
        containers: ['70720494449034970'],
      },
      {
        uid: '524531687763882763456719',
        pcs: '3456719',
        containers: ['52453168776388276'],
      },
      {
        uid: '650064158993262713456720',
        pcs: '3456720',
        containers: ['65006415899326271'],
      },
      {
        uid: '46715984426380183456721',
        pcs: '3456721',
        containers: ['4671598442638018'],
      },
      {
        uid: '26121829392870763456722',
        pcs: '3456722',
        containers: ['2612182939287076'],
      },
      {
        uid: '259317675349319223456723',
        pcs: '3456723',
        containers: ['25931767534931922'],
      },
      {
        uid: '125214254872571303456724',
        pcs: '3456724',
        containers: ['12521425487257130'],
      },
    ],
  },
};
